<template>
    <div class="account-content">
        <div class="head-box">
            <div class="left-box">
                <img class="select-img" :src="select_img" alt="" />
                <el-select ref="select" v-model="value" placeholder="请选择" @change="changeSelection" :popper-append-to-body="false">
                    <el-option v-for="item in studentList" :key="item.id" :label="item.name" :value="item.id">
                        <img :src="item.head_portrait === '' ? blank_headPic : item.head_portrait" alt="" width="30" height="30" />
                        <span>{{ item.name }}</span>
                    </el-option>
                </el-select>
            </div>
            <div class="right-box">
                <el-button class="purple-btn" @click="goBack">返回</el-button>
            </div>
        </div>
        <div class="account-info-box">
            <div class="head-time">
                数据统计时间：{{ today }}
                <span @click="getDate" class="update-title"><i class="iconfont">&#xe64d;</i></span>
            </div>
            <div class="main-content">
                <div class="left-box">
                    <div class="top-box">
                        <div class="head-pic">
                            <img :src="studentInfo.head_portrait === '' ? blank_headPic : studentInfo.head_portrait" alt="" />
                        </div>
                        <div class="head-info">
                            <div class="account-name">{{ studentInfo.name }}</div>
                            <div class="account-phone">班级：{{ className }}</div>
                        </div>
                    </div>
                    <!-- <div class="bottom-box">
                        <div class="icon-box" @click="viewReport">
                            <i class="iconfont">&#xe791;</i>
                        </div>
                        <div class="bottom-text" @click="viewReport">能力报告</div>
                    </div> -->
                </div>
                <div class="middle-box">
                    <div class="info-box" v-for="(item, index) in infoList" :key="index">
                        <div class="top-box">
                            <div class="icon-box">
                                <i class="iconfont" v-html="item.icon" :style="{ color: item.color }"></i>
                            </div>
                            <div class="top-title">
                                {{ item.title }}
                            </div>
                            <div class="top-question">
                                <el-popover placement="top" trigger="hover" popper-class="popover-box" :content="item.description">
                                    <i class="el-icon-question" slot="reference" v-if="item.description"></i>
                                </el-popover>
                            </div>
                        </div>
                        <div class="bottom-box">{{ item.content === "" ? "0" : item.content }}</div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="right-main-content">
                        <div class="right-box-item">
                            <div class="item-top">完成企业任务</div>
                            <div class="item-bottom">
                                <!-- {{studentInfo.qyrw_count}} -->
                                {{ taskInfo.enterprise }}
                            </div>
                        </div>
                        <div class="right-box-item">
                            <div class="item-top">完成教师任务</div>
                            <div class="item-bottom">
                                <!-- {{studentInfo.jsrw_count}} -->
                                {{ taskInfo.teacher }}
                            </div>
                        </div>
                    </div>
                    <div class="right-bottom">
                        <el-button class="purple-btn" @click="gotoDetail">查看详情</el-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="show-box">
            <ShortVideo ref="shortVideoRef" title="短视频数据" :all="true" :userId="account_id"></ShortVideo>
        </div>

        <div class="show-box">
            <LiveStreaming ref="liveStreamingRef" title="直播数据" :all="true" :userId="account_id"></LiveStreaming>
        </div>

        <div class="show-box no-padding">
            <FanPortrait ref="fanPortraitRef" :isHeader="false" :all="true" :userId="account_id"></FanPortrait>
        </div>

        <div class="left-item-fan end">
            <div class="item-half-sub">账号数据列表</div>
            <div class="left-item-content">
                <el-table
                    :data="tabelList"
                    class="college-table"
                    height="780"
                    size="medium"
                    :header-cell-style="{ fontWeight: '400', color: '#333', background: '#F8F8FD', height: '50px' }"
                    :cell-style="{ fontSize: '16px', color: '#333', fontWeight: 'bold' }"
                    :row-style="{ height: '100px' }"
                >
                    <el-table-column prop="platform_type" label="平台" align="left" width="200" class-name="platform-head">
                        <template slot-scope="scope">
                            <div class="account-number platform">
                                <img
                                    :src="
                                        scope.row.platform_type === 1
                                            ? require('../../../assets/img/image/douyin.png')
                                            : require('../../../assets/img/image/baijiahao.png')
                                    "
                                />
                                <span class="scope-title">{{ scope.row.platform_type === 1 ? "抖音号" : "百家号" }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="user_name" label="账号信息" align="left" width="500" class-name="student-name">
                        <template slot-scope="scope">
                            <div class="account-number">
                                <img
                                    :src="
                                        scope.row.avatar === null
                                            ? require('../../../assets/img/image/blank_headPic.png')
                                            : scope.row.avatar
                                    "
                                    alt=""
                                    width="30"
                                    height="30"
                                />
                                <span class="scope-title">{{ scope.row.nickname }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="follower_count" label="粉丝数" align="center" class-name="student-name">
                        <template slot-scope="scope">
                            <span class="student-name-title">{{ scope.row.follower_count }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="aweme_count" label="作品总数" align="center" class-name="student-name">
                        <template slot-scope="scope">
                            <span class="student-name-title" v-if="scope.row.type === 1">{{ scope.row.aweme_count }}</span>
                            <span class="student-name-title" v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="favoriting_count" label="点赞总数" align="center" class-name="student-name">
                        <template slot-scope="scope">
                            <span class="student-name-title" v-if="scope.row.type === 1">{{ scope.row.favoriting_count }}</span>
                            <span class="student-name-title" v-else>暂无</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <div class="icon-box">
                                <div class="icon-content" @click="gotoData(scope.row)">
                                    <i class="iconfont">&#xe676;</i>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    class="circle-page"
                    :current-page="currentPageNum"
                    :page-size="eachPageNum"
                    layout="prev, pager, next, total"
                    :total="total"
                    @current-change="classCurrentChange"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import { mapGetters } from "vuex";
import taskApi from "../../../apis/task";
import ShortVideo from "../../../components/dataCenter/ShortVideo.vue";
import LiveStreaming from "../../../components/dataCenter/LiveStreaming.vue";
import FanPortrait from "../../student/creativecenter/dataCenter/FanPortrait.vue";

export default {
    name: "accountDetail",
    data() {
        return {
            accountInfo: {},
            studentList: [],
            value: "",
            infoList: [
                {
                    icon: "&#xe699;",
                    color: "#FF6D80",
                    title: "粉丝数",
                    content: "",
                },
                {
                    icon: "&#xe7fd;",
                    color: "#5F55F1",
                    title: "作品总数",
                    content: "",
                },
                {
                    icon: "&#xe685;",
                    color: "#04A8FF",
                    title: "点赞总数",
                    content: "",
                },
                {
                    icon: "&#xe684;",
                    color: "#9ACC5B",
                    title: "平均点赞",
                    content: "",
                    description: "近15天内作品的点赞数/作品数",
                },
                {
                    icon: "&#xe806;",
                    color: "#4588F9",
                    title: "平均评论",
                    content: "",
                },
                {
                    icon: "&#xe627;",
                    color: "#FFB624",
                    title: "平均转发",
                    content: "",
                },
            ],
            today: "",
            fanTabIndex: 0,
            dzTabIndex: 0,
            liveTabIndex: 0,
            areaData: [],
            man: 0,
            woman: 0,
            account_id: "",
            class_id: "",
            select_img: "",
            blank_headPic: require("../../../assets/img/image/blank_headPic.png"),
            studentInfo: {},
            taskInfo: {
                // 学生任务数据
                enterprise: 0,
                teacher: 0,
            },
            className: "",
            accountList: [],
            FansTrend: [],
            likesTrend: [],
            liveTrend: [],
            genderData: [],
            age: [],
            tabelList: [],
            currentPageNum: 1,
            eachPageNum: 10,
            total: 0,
            //直播没有数据提示
            LiveTrendNoPrompt: null,
        };
    },
    mounted() {
        this.getParam();
        this.getDate();
    },

    components: {
        ShortVideo,
        LiveStreaming,
        FanPortrait,
    },

    computed: {
        ...mapGetters(["getAccountInfo"]),
    },
    methods: {
        ...mapMutations(["setStudentInfo", "setAccountInfo"]),
        getParam() {
            this.accountInfo = this.getAccountInfo;
            this.account_id = this.accountInfo.account_id;
            this.class_id = this.accountInfo.class_id;
            this.className = this.accountInfo.class_name;
            this.value = JSON.parse(this.account_id);
        },
        getDate() {
            let myDate = new Date();
            this.today = this.formatDate(myDate.getTime());
            this.changeSelection(this.account_id);
            this.getStudentInfo(this.class_id);

            this.getTaskInfo(this.account_id);
        },
        formatDate(date) {
            var date = new Date(date);
            var YY = date.getFullYear() + "-";
            var MM = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
            var DD = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hh = (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
            var mm = (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) + ":";
            var ss = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            return YY + MM + DD + " " + hh + mm + ss;
        },
        classCurrentChange(val) {
            this.currentPageNum = val;
            this.getTableList();
        },
        getData(id) {
            let param = {
                user_id: id,
            };
            this.$httpteacher.axiosGetBy(this.$api.account_userAccount, param, (res) => {
                if (res.code == 200) {
                    this.infoList[3].content = res.data.avg_likes;
                    this.infoList[4].content = res.data.avg_comment;
                    this.infoList[5].content = res.data.avg_forward;
                    this.FansTrend = res.data.history_fans;
                    this.likesTrend = res.data.history_likes;
                    this.liveTrend = res.data.live_data;
                    this.genderData = res.data.gender_distribution;
                    this.man = this.genderData[1].proportion;
                    this.woman = this.genderData[2].proportion;
                    // 年龄段
                    this.age = res.data.age_distribution;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        getStudentInfo(id) {
            let param = {
                class_id: id,
                type: "all",
            };
            this.$httpteacher.axiosGetBy(this.$api.account_userListStatistics, param, (res) => {
                if (res.code == 200) {
                    this.studentList = res.data;
                    this.getSingleStu();
                } else {
                    this.$message({
                        type: "error",
                        message: res.message,
                        duration: 1000,
                    });
                }
            });
        },
        getTableList() {
            let param = {
                paging: 1,
                user_id: this.account_id,
                page: this.currentPageNum,
                pageSize: this.eachPageNum,
            };
            this.$httpteacher.axiosGetBy(this.$api.get_account, param, (res) => {
                if (res.code == 200) {
                    this.tabelList = res.data.data;
                    this.total = res.data.total;
                } else {
                    this.$message({
                        type: "error",
                        message: res.message,
                        duration: 1000,
                    });
                }
            });
        },
        getTiktokData() {
            let params = {
                paging: 0,
                user_id: this.account_id,
            };

            this.$httpteacher.axiosGetBy(this.$api.get_account, params, (res) => {
                if (res.code == 200) {
                    const follower_count = res.data?.data?.reduce((prev, cur) => cur.follower_count + prev, 0);
                    const user_id = Number(this.account_id);

                    this.$refs.shortVideoRef?.getData?.(user_id);
                    this.$refs.liveStreamingRef?.getData?.(user_id);
                    this.$refs.fanPortraitRef?.getFans?.({ id: user_id, follower_count: follower_count });
                }
            });
        },

        getSingleStu() {
            for (let index in this.studentList) {
                let obj = this.studentList[index];
                if (obj.id == this.account_id) {
                    this.studentInfo = obj;
                    this.select_img = obj.head_portrait === "" ? this.blank_headPic : obj.head_portrait;
                }
            }
            this.infoList[0].content = this.studentInfo.fans_count;
            this.infoList[1].content = this.studentInfo.zp_count;
            this.infoList[2].content = this.studentInfo.dz_count;
        },
        changeSelection(e) {
            this.follower_data = [];
            let obj = {
                account_id: e,
                class_id: this.class_id,
                class_name: this.className,
            };
            this.setAccountInfo(obj);
            this.getData(e);
            this.account_id = e;
            this.getSingleStu();
            this.getTableList();
            this.getTiktokData();
            this.getTaskInfo(e); // 请求学生完成任务数据
            for (let index in this.studentList) {
                let obj = this.studentList[index];
                if (obj.id == e) {
                    this.select_img = obj.head_portrait === "" ? this.blank_headPic : obj.head_portrait;
                }
            }
        },

        // 获取企业任务数据
        getTaskInfo(id) {
            const params = { user_id: id };

            this.$httpteacher.axiosGetBy(taskApi.studentTaskInfo, params, (res) => {
                if (res.code === 200) {
                    this.taskInfo = {
                        enterprise: res.data?.enterprise ?? 0,
                        teacher: res.data?.teacher ?? 0,
                    };
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        goBack() {
            this.$router.push("/teacher/studentmang/index");
        },
        viewReport() {
            this.$message.warning("功能暂未开放");
        },
        gotoDetail() {
            // this.$message.warning('功能暂未开放')
            // this.setStudentInfo(this.studentInfo)
            this.$router.push({
                path: "/teacher/newTask/completion",
                query: {
                    id: this.account_id,
                    name: this.studentInfo.name,
                    avatar: this.studentInfo.head_portrait || this.blank_headPic,
                },
            });
        },

        gotoData(item) {
            if (item.type === 1) {
                this.$router.push({
                    path: "/teacher/data/details",
                    query: {
                        id: item.id,
                        user_id: this.account_id,
                    },
                });
            } else {
                this.$message({
                    type: "error",
                    message: "请选择抖音账号",
                    duration: 1000,
                });
            }
        },
    },
};
</script>

<style scoped lang="scss">
.account-content {
    min-width: 1400px;

    .popover-box {
        font-size: 12px;
        color: #444444;
        line-height: 20px;
    }

    .purple-btn {
        width: 90px;
        height: 30px;
        background: #564ced;
        border-radius: 6px;
        color: #ffffff;
        line-height: 0;
    }

    .head-box {
        width: 100%;
        height: 40px;
        display: flex;
        justify-content: space-between;
        position: relative;

        .left-box {
            background: #ffffff;
            border-radius: 4px;

            .select-img {
                width: 27px;
                height: 27px;
                border-radius: 50%;
                position: absolute;
                left: 10px;
                top: 6px;
                z-index: 1;
            }

            ::v-deep .el-input__inner {
                padding-left: 40px;
            }

            ::v-deep .el-input__suffix .el-input__suffix-inner .el-icon-arrow-up {
                &:before {
                    content: "\e78f";
                    color: #333333;
                }
            }

            ::v-deep .el-select-dropdown .el-select-dropdown__item {
                display: flex;
                align-items: center;

                span {
                    margin-left: 10px;
                }

                img {
                    width: 24px;
                    height: 24px;
                    border-radius: 50%;
                }
            }
        }
    }

    .show-box {
        margin-top: 20px;
        background-color: #ffffff;
        border-radius: 4px;
        padding: 0 16px 16px;

        &.no-padding {
            padding: 0;
        }

        ::v-deep .content-title {
            font-size: 18px;
        }
    }

    .account-info-box {
        background: #ffffff;
        margin-top: 15px;
        border-radius: 6px;

        .head-time {
            text-align: right;
            padding: 18px;
            color: #666666;
            font-size: 12px;

            .update-title {
                cursor: pointer;
                margin-left: 9px;

                i {
                    font-size: 14px;
                }
            }
        }

        .main-content {
            display: flex;

            .bottom-box {
                display: flex;
                justify-content: center;
                cursor: pointer;

                .icon-box {
                    width: 36px;
                    height: 37px;
                    border-radius: 50%;
                    background: #5e54f1;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    i {
                        font-size: 24px;
                    }
                }

                .bottom-text {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: 10px;
                }
            }
        }

        .left-box {
            margin: 40px 0 30px 45px;
            padding-right: 100px;
            border-right: 5px solid #eeeeee;

            .top-box {
                display: flex;

                .head-pic img {
                    width: 110px;
                    height: 110px;
                    border-radius: 50%;
                }

                .head-info {
                    width: 150px;
                    margin-left: 25px;

                    .account-name {
                        margin-top: 15px;
                        font-size: 20px;
                        color: #000000;
                        max-width: 150px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .account-phone {
                        margin-top: 45px;
                        font-size: 14px;
                        color: #888888;
                        max-width: 150px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }

            .bottom-box {
                margin-top: 60px;
                text-align: center;
            }

            .head-pic img {
                width: 110px;
                height: 110px;
            }
        }

        .middle-box {
            min-width: 700px;
            margin: 55px 0 30px 100px;
            border-right: 5px solid #eeeeee;
            display: flex;
            flex-wrap: wrap;

            .info-box {
                width: calc(33% - 80px);
                text-align: center;
                padding-left: 60px;

                .top-box {
                    display: flex;
                    padding-left: 25px;

                    i {
                        font-size: 24px;
                    }

                    .top-title {
                        font-size: 14px;
                        height: 100%;
                        color: #888888;
                        margin-left: 8px;
                    }

                    .top-question {
                        margin-left: 8px;
                        margin-top: 2px;

                        .el-icon-question {
                            font-size: 16px;
                            color: #645af1;
                            cursor: pointer;
                        }
                    }
                }

                .bottom-box {
                    text-align: center;
                    margin-top: 15px;
                    font-weight: bold;
                    color: #333333;
                    font-size: 24px;
                    max-width: 150px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                &:nth-of-type(3n + 1) {
                    padding-right: 30px;
                    padding-left: 0;
                }

                &:nth-of-type(3n + 2) {
                    position: relative;
                    padding-right: 40px;

                    &:before {
                        content: "";
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 1px;
                        height: 36px;
                        background: #eeeeee;
                    }

                    &:after {
                        content: "";
                        position: absolute;
                        top: 0;
                        right: 0;
                        width: 1px;
                        height: 36px;
                        background: #eeeeee;
                    }
                }
            }
        }

        .right-box {
            margin: 55px 0 30px 30px;
            padding-right: 50px;

            .right-main-content {
                display: flex;
            }

            .right-bottom {
                text-align: center;
                display: flex;
                justify-content: center;

                .purple-btn {
                    display: flex;
                    justify-content: center;
                    line-height: 4px;
                }
            }

            .right-box-item {
                position: relative;
                padding: 50px 35px;

                .item-top {
                    width: 84px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #888888;
                }

                .item-bottom {
                    margin-top: 30px;
                    font-weight: bold;
                    color: #333333;
                    font-size: 24px;
                    text-align: center;
                    max-width: 84px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                &:first-child {
                    &:after {
                        content: "";
                        position: absolute;
                        top: 60px;
                        right: 0;
                        width: 1px;
                        height: 36px;
                        background: #eeeeee;
                    }
                }
            }
        }
    }

    .left-item-fan {
        margin-bottom: 20px;
        margin-top: 20px;

        .item-half-sub {
            font-size: 16px;
            line-height: 24px;
            font-weight: 400;
            color: #000000;
        }

        .left-item-content {
            background: #fff;
            border-radius: 6px;
            margin-top: 15px;
            padding: 15px;

            ::v-deep.tooltip {
                height: 59px;
                border-radius: 2px;
                box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.11);
                background: #fff;

                &.double {
                    height: 91px;
                }

                .tooltip-box {
                    padding: 13px 20px 10px;
                }

                .tooltip-title {
                    font-size: 12px;
                    color: #999999;
                }

                .tooltip-title-right {
                    float: right;
                    padding-right: 10px;
                    font-size: 16px;

                    &.red {
                        color: #f5697b;
                    }

                    &.blue {
                        color: #5f55f1;
                    }

                    &.purple {
                        color: #5f55f1;
                    }
                }

                .tooltip-title-left {
                    color: #333;
                }
            }
        }

        &.end {
            margin-bottom: 0;
        }

        .college-table {
            width: 100%;
            margin-top: 22px;

            ::v-deep .el-table__header .platform-head {
                padding-left: 25px;
            }

            .account-number {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                height: 45px;

                &.platform {
                    padding-left: 20px;
                }

                img {
                    height: 36px;
                    width: 36px;
                    border-radius: 50%;
                }

                .scope-title {
                    width: 260px;
                    margin-left: 10px;
                    text-align: left;
                    color: #333;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    display: inline-block;
                    cursor: pointer;
                    font-size: 14px;
                    font-weight: 400;
                }
            }

            .icon-box {
                display: flex;
                justify-content: center;

                .icon-content {
                    width: 40px;
                    height: 40px;
                    background: #ff6a6a;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    i {
                        font-size: 20px;
                        color: #ffffff;
                    }
                }
            }
        }

        .circle-page {
            padding-top: 35px;
        }
    }
}
</style>
